import { RECEIVE_PERMISSIONS } from '../constants/ActionTypes';

const permissions = (state = [], action) => {
  switch (action.type) {
    case RECEIVE_PERMISSIONS:
      return action.payload.reduce((collection, permission) => {
        const { granted, permissionName } = permission;
        collection[permission.permissionCode] = {
          granted,
          permissionName
        };
        return collection;
      }, {});
    default:
      return state;
  }
}

export default permissions;



// WEBPACK FOOTER //
// ./src/reducers/permissions.js